<template>
  <div class="content ht-100v pd-0">
    <div class="content-header" slot="content-header">
      Идэвхтэй ажилбарууд
    </div>
    <div class="content-body pd-0">
      <div class="container pd-x-0 mg-b-0">
        <div class="card mg-t-20">
          <div
            class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-10"
          >
            <div>
              <h6 class="mg-b-5">Идэвхтэй ажилбарууд</h6>
              <p class="tx-13 tx-color-03 mg-b-0">тайлбар</p>
            </div>
            <div class="d-flex">
              <div class="btn-group flex-fill">
                <button
                  @click="
                    pager.current = 1;
                    seenFlag = null;
                    init();
                  "
                  class="btn btn-white btn-xs"
                  :class="{ active: seenFlag == null }"
                >
                  Бүгд
                </button>
                <button
                  @click="
                    pager.current = 1;
                    seenFlag = true;
                    init();
                  "
                  class="btn btn-white btn-xs"
                  :class="{ active: seenFlag == true }"
                >
                  Үзсэн
                </button>
                <button
                  @click="
                    pager.current = 1;
                    seenFlag = false;
                    init();
                  "
                  class="btn btn-white btn-xs"
                  :class="{ active: seenFlag == false }"
                >
                  Үзээгүй
                </button>
              </div>
            </div>
          </div>
          <!-- card-header -->
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Гарчиг</th>
                <th scope="col">Ажил хэрэг</th>
                <!-- <th scope="col">Бүртгэсэн</th> -->
                <th scope="col">Эхлэх дуусах</th>
              </tr>
            </thead>
            <tbody>
              <tr
                @click="showDetail(t)"
                role="button"
                v-for="(t, i) in tasks"
                :key="i"
                :class="{ 'bg-light': t.im != null && !t.im.seen }"
              >
                <th scope="row" class="text-muted">
                  {{ (pager.current - 1) * pager.perPage + i + 1 }}
                </th>
                <td class="wd-40p">
                  <div class=""> {{t.prefix}} - {{ t.task }}</div>
                </td>
                <td class="text-muted">{{ t.projectName }}</td>
                <!-- <td class="text-muted text-nowrap">{{t.dueStartDate | moment('YYYY.MM.DD HH:mm')}}</td> -->
                <td class="text-muted text-nowrap">
                  {{ t.dueStartDate | moment("YYYY.MM.DD HH:mm") }}
                  -
                  {{ t.dueDate | moment("MM.DD HH:mm") }}
                </td>
              </tr>
            </tbody>
          </table>
          <div class="card-footer text-center">
            <b-pagination
              v-show="tasksCount > 0"
              size="sm"
              align="center"
              v-model="pager.current"
              :total-rows="tasksCount"
              :per-page="pager.perPage"
              @change="pageChanged"
              style="margin-bottom: 0"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <task-detail-side
      v-if="taskDialog.id > 0"
      :id.sync="taskDialog.id"
      @on-task-detail="showDetail"
      @on-task-close="
        taskDialog.id = 0;
        taskLoaded();
      "
    ></task-detail-side>
  </div>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  mounted() {
    //this.featherReplace();
    this.init();
  },
  // updated(){
  //   this.featherReplace();
  // },
  data() {
    return {
      tasks: [],
      tasksCount: 0,
      pager: {
        perPage: 15,
        current: 1
      },
      taskDialog: {
        show: false,
        id: 0,
        key: 0
      },
      seenFlag: null
    };
  },
  methods: {
    ...mapActions(["handleLoading"]),
    taskLoaded(){
      
    },
    init() {
      request({
        api: { method: "post", url: "task/getPinnedTaskList" },
        data: {
          page: this.pager.current - 1,
          size: this.pager.perPage,
          seen: this.seenFlag
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks = res.data.tasks;
          if (this.seenFlag == null || this.seenFlag)
            this.tasksCount = res.data.count;
          else if (this.seenFlag == false)
            this.tasksCount = res.data.unseenCount;
          //console.log(res);
        }
      });
    },
    pageChanged(e) {
      this.pager.current = e;
      this.init();
    },
    showDetail(e) {
      this.handleLoading({ isLoading: true });
      this.taskDialog.id = e.id;
    }
  }
};
</script>

<style></style>
